/* global window: true, document: true */
import axios from 'axios';

// This module is used instead of directly using the Axios module to handle Unauthorized better.

// TODO: Extend with other options.
const axiosInstance = axios.create({});

// Only handling the errors right now because Unauthorized is always considered an error by Axios.
axiosInstance.interceptors.response.use(undefined, (error) => {
    // Don't think we need to handle the Promise because we are redirecting the user.
    if (error.response && error.response.status === 401) {
        window.location = `${window.location.origin}/login`;

        // Setting to the start of Unix time to make the browser expires the cookies.
        document.cookie = 'connect.sid=;expires=Thu, 01 Jan 1970 00:00:01 GMT;';
    }

    return Promise.reject(error);
});

export default axiosInstance;



/** WEBPACK FOOTER **
 ** ./client/lib/AxiosInstance.js
 **/